<template>
  <BaseTab>
    <div />
    <v-subheader>Help</v-subheader>
    <div class="ma-4">
      <h1>The 3-step "Why - What's Stopping" Analysis: </h1>
      <p />
      <p>1. Ask the complete question, either: "Why might you want to...?" or "What's stopping you from...?"</p>
      <p>2. The question is answered in a complete, simple sentence.</p>
      <p>3. The answer is re-stated as a new "How might...?"</p>
    </div>
    <v-btn
      @click="downloadManual"
      color="rgb(255, 149, 24)"
      style="margin-left: 20%"
    >
      Download UserManual
    </v-btn>
  </BaseTab>
</template>

<script>
import BaseTab from '@/components/base/BaseTab'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ThoughtCatcher',

  components: {
    BaseTab
  },

  data: () => ({
    addThoughtText: ''
  }),

  methods: {
    ...mapActions(['addPrivateThought', 'makeThoughtPublic']),
    handleAddThought () {
      if (this.addThoughtText !== '') {
        this.addPrivateThought(this.addThoughtText)
        this.addThoughtText = ''
      }
    },
    handlePrivateThoughtClick (thought) {
      this.makeThoughtPublic(thought.id)
    },
    downloadManual () {
      const link = document.createElement('a')
      link.setAttribute('type', 'hidden')
      link.href = require('@/assets/UserManual.png')
      console.error(link.href)
      link.download = 'UserManual.pdf'
      document.body.appendChild(link)
      link.click()
      link.remove()
    }
  },

  computed: {
    ...mapState(['publicThoughts', 'privateThoughts']),
    height: function () {
      return this.windowHeight - 60
    }
  }
}
</script>

<style lang="sass" scoped>
  .search-bar
    width: 250px
    top: 1em

  .add-thought-field
    width: 250px
    top: 1em
</style>
